import { render, staticRenderFns } from "./Scars.vue?vue&type=template&id=2f5f0660"
import script from "./Scars.vue?vue&type=script&lang=js"
export * from "./Scars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports